/**
 * Vídeos arqueados — autoplay mudo em sincronia; clique abre modal.
 */
(function () {
  var modal = null;
  var modalVideo = null;
  var modalTitle = null;
  var modalReady = false;

  function getVideoSrc(video) {
    if (!video) return '';
    if (video.currentSrc) return video.currentSrc;
    var source = video.querySelector('source');
    if (source && source.src) return source.src;
    return video.src || '';
  }

  function gridVideos(root) {
    if (!root) return [];
    return Array.prototype.slice.call(root.querySelectorAll('.md-pdp-jewelry-videos__video'));
  }

  function lockGridVideo(video) {
    if (!video || video === modalVideo) return;
    video.muted = true;
    video.defaultMuted = true;
    video.controls = false;
    video.removeAttribute('controls');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.playsInline = true;
    video.loop = true;
  }

  function tryPlay(video) {
    lockGridVideo(video);
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function playGridVideos(videos, shouldPlay) {
    videos.forEach(function (video) {
      if (shouldPlay) {
        tryPlay(video);
      } else {
        video.pause();
      }
    });
  }

  function ensureModal() {
    if (modal) return !!modalVideo;

    var modals = document.querySelectorAll('[data-md-jewelry-video-modal]');
    for (var i = 1; i < modals.length; i += 1) {
      modals[i].remove();
    }

    modal = document.querySelector('[data-md-jewelry-video-modal]');
    if (!modal) return false;

    modalVideo = modal.querySelector('[data-md-jewelry-video-modal-player]');
    modalTitle = modal.querySelector('[data-md-jewelry-video-modal-title]');
    if (!modalVideo) return false;

    if (!modalReady) {
      modalReady = true;

      modal.querySelectorAll('[data-md-jewelry-video-close]').forEach(function (btn) {
        btn.addEventListener('click', closeModal);
      });

      modal.addEventListener('cancel', function (event) {
        event.preventDefault();
        closeModal();
      });

      modal.addEventListener('click', function (event) {
        if (event.target === modal) closeModal();
      });
    }

    return true;
  }

  function closeModal() {
    if (!modal || !modal.open) return;

    modalVideo.pause();
    modalVideo.removeAttribute('src');
    modalVideo.load();
    modal.close();
    document.body.classList.remove('md-pdp-jewelry-video-modal-open');
  }

  function openModal(sourceVideo, title) {
    if (!ensureModal()) return;

    var src = getVideoSrc(sourceVideo);
    if (!src) return;

    document.querySelectorAll('.md-pdp-jewelry-videos__video').forEach(lockGridVideo);

    modalVideo.src = src;
    modalVideo.loop = true;
    modalVideo.playsInline = true;
    modalVideo.setAttribute('playsinline', '');
    modalVideo.setAttribute('webkit-playsinline', '');
    modalVideo.controls = true;
    modalVideo.muted = true;

    if (modalTitle) {
      modalTitle.textContent = title || '';
      modalTitle.hidden = !title;
    }

    modal.showModal();
    document.body.classList.add('md-pdp-jewelry-video-modal-open');
    modalVideo.play().catch(function () {});
  }

  function bindTriggers(strip) {
    strip.querySelectorAll('[data-md-jewelry-video-open]').forEach(function (trigger) {
      if (trigger.dataset.mdJewelryVideoBound === '1') return;
      trigger.dataset.mdJewelryVideoBound = '1';

      function openFromTrigger() {
        var video = trigger.querySelector('.md-pdp-jewelry-videos__video');
        if (!video) return;
        openModal(video, trigger.getAttribute('data-md-jewelry-video-title') || '');
      }

      trigger.addEventListener('click', openFromTrigger);
      trigger.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        openFromTrigger();
      });
    });
  }

  function initStrip(strip) {
    if (strip.dataset.mdJewelryStripInit === '1') return;
    strip.dataset.mdJewelryStripInit = '1';

    var videos = gridVideos(strip);
    if (!videos.length) return;

    var isPlaying = false;

    videos.forEach(function (video) {
      lockGridVideo(video);
      video.addEventListener('volumechange', function () {
        lockGridVideo(video);
      });
      video.addEventListener('loadeddata', function () {
        if (isPlaying) tryPlay(video);
      });
    });

    bindTriggers(strip);

    function setAllPlaying(shouldPlay) {
      if (isPlaying === shouldPlay) return;
      isPlaying = shouldPlay;
      playGridVideos(videos, shouldPlay);
    }

    if (typeof IntersectionObserver === 'undefined') {
      setAllPlaying(true);
      return;
    }

    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          setAllPlaying(entry.isIntersecting);
        });
      },
      { threshold: 0.08, rootMargin: '80px 0px 80px 0px' }
    ).observe(strip);
  }

  function boot() {
    ensureModal();
    document.querySelectorAll('[data-md-jewelry-strip]').forEach(initStrip);
    document.querySelectorAll('[data-md-arched-videos]').forEach(function (el) {
      if (el.closest('[data-md-jewelry-strip]')) return;
      initStrip(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
